import React, { useRef, useState, useEffect } from "react";
import { useMemo } from "react";
import "./Home.css";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import Slider from "../components/slider/slider";
import Footer from "../components/footer/footer";
import Header from "../components/Navbar";
import Slider2 from "../components/slider2/slider2";

import Pbottom from "../myimgs/Group53.png";
import layer1 from "../myimgs/Layer_1.png";
import layer2 from "../myimgs/Layer_2.png";
import arowr from "../myimgs/Vector.png";

import b1 from "../myimgs/Twoffers_banner/1.jpg";
import b2 from "../myimgs/Twoffers_banner/2.jpg";
import b3 from "../myimgs/Twoffers_banner/3.jpg";
import b4 from "../myimgs/Twoffers_banner/4.jpg";
import buyVideo from "../../src/myimgs/HowToBuy.mp4";
import sellVideo from "../../src/myimgs/HowToSell.mp4";
import mlsVideo from "../../src/myimgs/HowToSellWithMlNumber.mp4";
import play from "../myimgs/play-button-arrowhead.png";
import playIcon from "../myimgs/playIcon.png";
import Video from "../myimgs/Buy_Explore.mp4";
import TwoffersMLS from "../myimgs/TwoffersMLS.mp4";
import Howtosales from "../myimgs/HowToSells.mp4";
import addimage from "../myimgs/Banner_New 2.jpg";

import { Link } from "react-router-dom";

const Home = () => {
  const [mode, setMode] = useState("buy");
  const images = [b1, b2, b3, b4];
  const [currentImage, setCurrentImage] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [activeVideo, setActiveVideo] = useState(Video);
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Ad states
  const [ads, setAds] = useState([]);
  const [currentAdImage, setCurrentAdImage] = useState(0);

  // Properly encoded ad image URLs
  const adImages = useMemo(() => {
    const images = ads.flatMap((ad) =>
      (ad?.media || []).map((m) => {
        if (!m?.url) return null;
        try {
          const url = new URL(m.url);
          url.pathname = url.pathname
            .split("/")
            .map((seg) => encodeURIComponent(decodeURIComponent(seg)))
            .join("/");
          return url.toString();
        } catch {
          return m.url.replace(/ /g, "%20");
        }
      }),
    );

    // remove null + duplicates
    return [...new Set(images.filter(Boolean))];
  }, [ads]);

  // Open / close video modal
  const openVideo = (src) => {
    setVideoSrc(src);
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
    setVideoSrc("");
  };

  // Preload hero images
  useEffect(() => {
    let loadedCount = 0;
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) setLoaded(true);
      };
    });
  }, [images]);

  // Reset video on source change
  useEffect(() => {
    if (!videoRef.current) return;
    const video = videoRef.current;
    video.pause();
    video.currentTime = 0;
    setIsPlaying(false);
  }, [activeVideo]);

  useEffect(() => {
    if (videoRef.current && activeVideo) {
      videoRef.current.load();
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  }, [activeVideo]);

  // Hero background slideshow
  useEffect(() => {
    if (!loaded) return;
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [loaded, images.length]);

  // Fetch nearby ads
  // useEffect(() => {
  //   const fetchAds = async () => {
  //     try {
  //       const lat = 28.522404;
  //       const lng = 77.2370089;
  //       const baseUrl = process.env.REACT_APP_API_BASE_URL;
  //       const response = await fetch(
  //         `${baseUrl}/advertise/nearby/ads?lat=${lat}&lng=${lng}`,
  //       );
  //       const result = await response.json();
  //       console.log("Ads API Response:", result);
  //       if (result?.status === 200) {
  //         setAds(result.data || []);
  //       } else {
  //         setAds([]);
  //       }
  //     } catch (error) {
  //       console.log("Ads API Error:", error);
  //     }
  //   };
  //   fetchAds();
  // }, []);
  useEffect(() => {
    const fetchAds = async (lat, lng) => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;

        const response = await fetch(
          `${baseUrl}/advertise/nearby/ads?lat=${lat}&lng=${lng}`,
        );

        const result = await response.json();
        console.log("Ads API Response:", result);

        if (result?.status === 200) {
          setAds(result.data || []);
        } else {
          setAds([]);
        }
      } catch (error) {
        console.log("Ads API Error:", error);
      }
    };

    // 🔥 GET USER LOCATION
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      console.log("User Location:", lat, lng);

      fetchAds(lat, lng); // direct API call
    });
  }, []);
  // Ad images slideshow — depends on ads (stable), not adImages (re-created every render)
  useEffect(() => {
    if (adImages.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentAdImage((prev) => (prev + 1) % adImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [adImages.length]);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handlePause = () => {
    videoRef.current.pause();
    setIsPlaying(false);
  };

  const handleVideoChange = (video) => {
    setActiveVideo(video);
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="hero-section scrolleffect">
        {images.map((img, index) => (
          <div
            key={index}
            className={`bg-slide ${index === currentImage ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}

        <div className="bg-overlay"></div>

        <div className="overlay">
          <div className="container text-white hero-content">
            <div className="row">
              <div className="col-md-9 homseccol1">
                <ToggleButtonGroup
                  type="radio"
                  name="options"
                  value={mode}
                  onChange={(val) => setMode(val)}
                  className="mb-4"
                >
                  <ToggleButton
                    id="tbg-radio-1"
                    value="buy"
                    variant="light"
                    className="px-4 fw-bold"
                  >
                    Buy
                  </ToggleButton>
                  <ToggleButton
                    id="tbg-radio-2"
                    value="sell"
                    variant="light"
                    className="px-4 fw-bold"
                  >
                    Sell
                  </ToggleButton>
                </ToggleButtonGroup>

                <p className="subtitle">
                  {mode === "buy" ? (
                    <>Buy Anytime 24/7, 365 Days</>
                  ) : (
                    <>Sell Anytime 24/7, 365 Days</>
                  )}
                </p>

                <div className="pimg mb-4">
                  <img src={Pbottom} alt="" />
                </div>

                <h1 className="fw-bold display-5 hmergn">
                  {mode === "buy" ? (
                    <>
                      With 24/7 Canada-wide listings, you can browse, submit
                      offers, and close deals anytime because opportunity never
                      sleeps.
                    </>
                  ) : (
                    <>
                      Stay visible and ready. List your property and receive
                      offers anytime because buyers don't wait, and neither
                      should you.
                    </>
                  )}
                </h1>

                {mode === "buy" ? (
                  <Link to="/buyer">
                    <button className="arowr">
                      Explore All Properties <img src={arowr} alt="" />
                    </button>
                  </Link>
                ) : (
                  <Link to="/profile">
                    <button className="arowr">
                      List Your Property <img src={arowr} alt="" />
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Second Section */}
      <section className="w-full bg-gray-50 py-16">
        <div className="container homesecndsecn">
          <div className="row">
            <div className="col-md-6 d-flex homesecndcol gap-3 align-items-center">
              <img src={layer1} alt="" />
              <div className="lines"></div>
              <div className="para">
                <h3>Buy Property with Confidence</h3>
                <p>
                  Explore verified listings, get expert advice, and find the{" "}
                  <br></br>
                  perfect property that fits your lifestyle and budget.
                </p>
                <button
                  onClick={() => openVideo(buyVideo)}
                  className="view-btns"
                >
                  <img src={play} alt="" />
                  How to Buy / Explore
                </button>
              </div>
            </div>
            <div className="col-md-6 d-flex homesecndcol gap-3 align-items-center">
              <img src={layer2} alt="" />
              <div className="lines"></div>
              <div className="para">
                <h3>Ready to Sell Your Property</h3>
                <p>
                  Get the best value for your property with expert support,
                  verified buyers, and a smooth selling process from start to
                  finish.
                </p>
                <div className="disvbtnflx">
                  <button
                    onClick={() => openVideo(sellVideo)}
                    className="view-btns"
                  >
                    <img src={play} alt="" /> How to Sell
                  </button>
                  <button
                    onClick={() => openVideo(mlsVideo)}
                    className="view-btns nji"
                    style={{ marginLeft: "12px" }}
                  >
                    <img src={play} alt="" /> How to Sell By MLS No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Slider />
      <Slider2 />

      {/* Ads Slideshow Section*/}
      {/* <section className="ads-section py-5">
        <div className="container text-center">
          <h2 className="fw-bold" style={{ marginBottom: "40px" }}>
            Nearby Ads
          </h2>

          {adImages.length > 0 ? (
            <div className="ads-slider-unique">
              {adImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Ad ${index}`}
                  className={`ad-slide ${
                    index === currentAdImage ? "active" : ""
                  }`}
                />
              ))}
            </div>
          ) : (
            <p>No Ads Available</p>
          )}
        </div>
      </section> */}
      <section className="w-full bg-gray-50 py-16">
        <div className="container weltrudis">
          <div className="row">
            <div className="col-md-12">
              <h2 className="fw-bold" style={{ marginBottom: "40px" }}>
                Our partners in Growth
              </h2>
             <a href="https://www.gtabusinesssolutions.com" target="_blank" rel="noopener noreferrer">
  <img src={addimage} alt="link-img" />
</a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Twoffers Section */}
      <section className="w-full bg-gray-50 py-16">
        <div className="container weltrudis">
          <div className="row">
            <div className="col-md-12">
              <h2 className="fw-bold">Why Twoffers?</h2>
              <p className="pt-2">
                We simplify the property journey for everyone buyers, sellers,
                and investors. Browse verified listings, place real offers, and
                connect directly all on one transparent platform.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* For Buyers / Sellers Section */}
      <section className="w-full bg-gray-50 py-16 forbyrbtn">
        <div className="container lkiourls">
          <div className="row lineul">
            <div className="col-md-4">
              <ul>
                <h2>FOR BUYERS</h2>
                <li>
                  Offer on multiple properties at the same time with ease.
                </li>
                <li>Need help? We'll connect you to a local professional.</li>
                <li>Our in-house team is also ready to assist you.</li>
                <li>
                  Find your ideal property with expert or self-guided support.
                </li>
              </ul>
              <button
                className={`view-btns ${activeVideo === Video ? "active-btn" : ""}`}
                onClick={() => handleVideoChange(Video)}
                style={{ marginLeft: "15px" }}
              >
                <img src={play} alt="" /> How to Buy / Explore
              </button>
            </div>

            <div className="col-md-4 mile">
              <div className="video-wrapper">
                <video
                  ref={videoRef}
                  className="custom-video"
                  src={activeVideo}
                  preload="auto"
                  playsInline
                  onClick={handlePause}
                />
                {!isPlaying && (
                  <div className="play-overlay" onClick={handlePlay}>
                    <img src={playIcon} alt="Play" />
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4 mil2">
              <ul>
                <h2>FOR SELLERS</h2>
                <li>
                  Promote your property through your professional realtor on our
                  platform.
                </li>
                <li>No agent? We'll help you find one in your area.</li>
                <li>
                  Prefer doing it yourself? List directly and get multiple
                  offers.
                </li>
                <li>Reach more buyers with flexible listing options.</li>
                <div className="disvbtnflx">
                  <button
                    className={`view-btns nji ${activeVideo === Howtosales ? "active-btn" : ""}`}
                    onClick={() => handleVideoChange(Howtosales)}
                  >
                    <img src={play} alt="" /> How to Sell
                  </button>
                  <button
                    className={`view-btns nji ${activeVideo === TwoffersMLS ? "active-btn" : ""}`}
                    onClick={() => handleVideoChange(TwoffersMLS)}
                  >
                    <img src={play} alt="" /> How to Sell By MLS No
                  </button>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-gray-50 py-16">
        <div className="container-fluid"></div>
      </section>

      {/* Video Modal */}
      {showVideo && (
        <div className="video-modal">
          <div className="video-content">
            <button className="close-btn" onClick={closeVideo}>
              ✕
            </button>
            <video controls autoPlay>
              <source src={videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Home;
